import { render, staticRenderFns } from "./statistic_platform_user.vue?vue&type=template&id=50b58e5d&scoped=true"
import script from "./statistic_platform_user.vue?vue&type=script&lang=js"
export * from "./statistic_platform_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b58e5d",
  null
  
)

export default component.exports